import TileState from 'ol/TileState.js';

// Límite práctico de largo de URL antes de que los servidores empiecen a rechazarla.
const MAX_URL_LENGTH = 1800;

/**
 * Carga un mosaico. Si la URL quedó demasiado larga (típico al filtrar por geometría),
 * la misma petición se manda por POST y la respuesta se inyecta como imagen.
 *
 * Ante un fallo hay que marcar el mosaico con TileState.ERROR: sin eso OpenLayers
 * nunca emite tileloadend ni tileloaderror para él, el mosaico queda en estado
 * "cargando" para siempre y el aviso de carga del mapa no se apaga nunca.
 */
export const longRequestTileLoader = (tile, src) => {
    const image = tile.getImage();
    if (src.length < MAX_URL_LENGTH) { image.src = src; return; }
    const separator = src.indexOf('?');
    if (separator < 0) { image.src = src; return; }
    fetch(src.slice(0, separator), {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: src.slice(separator + 1),
    }).then(response => {
        if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);
        return response.blob();
    }).then(blob => {
        const objectUrl = URL.createObjectURL(blob);
        image.onload = () => URL.revokeObjectURL(objectUrl);
        image.src = objectUrl;
    }).catch(error => {
        console.error('No se pudo cargar un tile filtrado:', error);
        tile.setState(TileState.ERROR);
    });
};
